var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.screenType === 1)?_c('P4KIndex',{staticStyle:{"width":"1920px","height":"1080px","position":"fixed","left":"-576px","top":"-100px","transform":"scale(0.625,0.84375)"}}):_vm._e(),(_vm.screenType === 2)?_c('PMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }